import * as React from "react";
import { useEffect, useState } from "react";
import {
  ICommandBarItemProps,
  Icon,
  IContextualMenuItemStyles,
  IStyleFunctionOrObject,
  ICommandBarStyleProps,
  ICommandBarStyles,
  TooltipHost,
  TextField,
  Stack,
  FontIcon,
} from "@fluentui/react";
import { IPERCUbicacion } from "../../Interfaces/IIPERC";
import { useBoolean } from "@fluentui/react-hooks";
import {
  mergeStyleSets,
  getTheme,
  concatStyleSets,
} from "@fluentui/react/lib/Styling";
import IPERCService from "../../services/IPERCService";
import { useLocation, useParams } from "react-router-dom";
import {
  CommandBarButton,
  IButtonProps,
  IButtonStyles,
} from "@fluentui/react/lib/Button";
import { DefaultButton, PrimaryButton } from "@fluentui/react/lib/Button";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";
import { useNavigate } from "react-router-dom";
import {
  DetailsList,
  DetailsListLayoutMode,
  IColumn,
  SelectionMode,
} from "@fluentui/react/lib/DetailsList";
import { Panel, PanelType } from "@fluentui/react/lib/Panel";
import { Dialog, DialogType, DialogFooter } from "@fluentui/react/lib/Dialog";
import { ProgressIndicator } from "@fluentui/react/lib/ProgressIndicator";
import HeaderTable from "../../components/generic/HeaderTable";
import { TableBase } from "../../components/Table/TableBase";
import IconHelper from "../../utils/helpers/iconHelper";
import { ConfigHelper } from "../../utils/helpers/configHelper";
import HelpersIpercBase from "../../utils/helpers/HelpersIpercBase";
import COLORES from "../../utils/theme/colores";

const classNames = mergeStyleSets({
  fileIconHeaderIcon: {
    padding: 0,
    fontSize: "16px",
  },
  iconFont: {
    padding: 0,
    fontSize: "16px",
    marginRight: 5,
  },
  iconFontGreen: {
    padding: 0,
    fontSize: "16px",
    marginRight: 5,
    color: "#004b1c",
    fontWeight: "bold",
  },
  fileIconCell: {
    textAlign: "center",
    selectors: {
      "&:before": {
        content: ".",
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0px",
        visibility: "hidden",
      },
    },
  },
  fileIconImg: {
    verticalAlign: "middle",
    maxHeight: "16px",
    maxWidth: "16px",
  },
  controlWrapper: {
    display: "flex",
    flexWrap: "wrap",
  },
  exampleToggle: {
    display: "inline-block",
    marginBottom: "10px",
    marginRight: "30px",
  },
  selectionDetails: {
    marginBottom: "20px",
  },
});

interface formModel {
  areaId: any;
  ubicacionId: string;
  nombre: string;
}

const INITIAL_MODULE = {
  areaId: "",
  ubicacionId: "",
  nombre: "",
};

function IPERCUbicaciones() {
  //const location = useLocation();
  const data: IPERCUbicacion[] = [];
  const [items, setItems] = useState(data);
  const [itmesPanel, setItemsPanel] = useState(data);
  const [openPanel, setOpenPanel] = useState(false);
  const [openPanel2, setOpenPanel2] = useState(false);
  const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
  const [hideDialog2, { toggle: toggleHideDialog2 }] = useBoolean(true);
  const theme = getTheme();
  // let { id } = useParams();
  //const { areaId } = location.state.areaId || {};

  //const id = location.state.areaId;
  const { state } = useLocation();
  const dataLocation: any = state;
  var id =
    dataLocation != undefined &&
      dataLocation != null &&
      dataLocation.hasOwnProperty("areaId")
      ? dataLocation.areaId
      : "";

  let navigate = useNavigate();
  const [hideDialogSuccess, { toggle: toggleHideDialogSuccess }] =
    useBoolean(true);
  const [hideDialogSuccess2, { toggle: toggleHideDialogSuccess2 }] =
    useBoolean(true);
  const [hideDialogError, { toggle: toggleHideDialogError }] = useBoolean(true);
  const [hideDialogError2, { toggle: toggleHideDialogError2 }] =
    useBoolean(true);

  const [selectedUbicacion, setSelectedUbicacion] = useState<string>("");
  const [selectedNivel, setSelectedNivel] = useState<string>("");
  function LoadData() {
    var obj: any = {};
    obj.AreaId = id;
    IPERCService.listarUbicaciones(obj).then((x) => {
      setItems(x.data);
    });
  }
  useEffect(() => {
    LoadData();
  }, []);

  function LoadData2(ubicacionId: any) {
    var obj: any = {};
    obj.ubicacionId = ubicacionId;
    IPERCService.listarNivelUbicacion(obj).then((x) => {
      setItemsPanel(x.data);
      console.log("data dinamica", itmesPanel);
    });
  }
  const [model, setmodel] = useState<formModel>(INITIAL_MODULE);
  const [hideDialogDelete, { toggle: toggleHideDialogDelete }] =
    useBoolean(true);

  const [hideDialogDelete2, { toggle: toggleHideDialogDelete2 }] =
    useBoolean(true);

  const itemStyles: Partial<IContextualMenuItemStyles> = {
    label: { fontSize: 13 },
    icon: { color: theme.palette.blue },
    iconHovered: { color: theme.palette.blueDark },
  };

  const _farItems: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_BACK,
      text: "Atrás",
      onClick: () => {
        navigate(`${ConfigHelper.urlBase()}/iperc/Configuraciones/areas`);
      },
      // onClick: () => { navigate('/ssoma/iperc/areas') }
    },
  ];
  const _CommandBarItemItems: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_ADD,
      text: "Nuevo",
      onClick: () => {
        setmodel(INITIAL_MODULE);
        setOpenPanel(true);
        // setEsEditable(false);
      },
    },
  ];
  const getCommandBarButtonStyles = memoizeFunction(
    (
      originalStyles: IButtonStyles | undefined
    ): Partial<IContextualMenuItemStyles> => {
      if (!originalStyles) {
        return itemStyles;
      }
      return concatStyleSets(originalStyles, itemStyles);
    }
  );

  const CustomButton: React.FunctionComponent<IButtonProps> = (props) => {
    const buttonOnMouseClick = () => alert(`${props.text} clicked`);
    // eslint-disable-next-line react/jsx-no-bind
    return (
      <CommandBarButton
        {...props}
        //onClick={buttonOnMouseClick}
        styles={getCommandBarButtonStyles(props.styles)}
      />
    );
  };

  const _columns: IColumn[] = [
    {
      key: "nombre",
      name: "Nombre",
      fieldName: "nombre",
      minWidth: 400,
      maxWidth: 500,
      isResizable: true,
      isMultiline: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      fieldName: "opciones",
      minWidth: 70,
      maxWidth: 90,
      isResizable: true,
      isCollapsible: true,
      data: "number",
      onRender: (item: IPERCUbicacion) => (
        <>
          <TooltipHost content={"Niveles"}>
            <Icon
              iconName="GroupedList"
              className={classNames.iconFont}
              style={{ cursor: "pointer", color: "black" }}
              onClick={() => {
                //   toggleHideDialog2();
                setSelectedUbicacion(item.ubicacionId!);
                setOpenPanel2(true);
                LoadData2(item.ubicacionId);
                setmodel({ ...model, ubicacionId: item.ubicacionId });
              }}
            />
          </TooltipHost>
          <TooltipHost content={"Eliminar"}>
            <Icon
              iconName="Trash"
              className={classNames.iconFont}
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => {
                setSelectedUbicacion(item.ubicacionId!);
                toggleHideDialogDelete();
                setmodel({ ...model, ubicacionId: item.ubicacionId });
              }}
            />
          </TooltipHost>
        </>
      ),
    },
  ];

  const _columnsPanel: IColumn[] = [
    {
      key: "nombre",
      name: "Nombre",
      fieldName: "nombre",
      minWidth: 300,
      maxWidth: 400,
      isResizable: true,
      isMultiline: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      fieldName: "opciones",
      minWidth: 70,
      maxWidth: 90,
      isResizable: true,
      isCollapsible: true,
      data: "number",
      onRender: (item: IPERCUbicacion) => (
        <>
          <TooltipHost content={"Eliminar"}>
            <Icon
              iconName="Trash"
              className={classNames.iconFont}
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => {
                toggleHideDialogDelete2();
                setSelectedNivel(item.ubicacionId);
                setmodel({ ...model, ubicacionId: item.ubicacionId });
              }}
            />
          </TooltipHost>
        </>
      ),
    },
  ];

  const commadStyles: IStyleFunctionOrObject<
    ICommandBarStyleProps,
    ICommandBarStyles
  > = {
    root: {
      padding: 0,
      margin: 0,
    },
  };

  const buttonStyles = { root: { marginRight: 8 } };
  const onRenderFooterContent = React.useCallback(
    () => (
      <div>
        <PrimaryButton
          onClick={() => {
            toggleHideDialog();
            let body: any = {};
            body.areaId = id;
            body.nombre = model.nombre;
            IPERCService.agregarUbicaciones(body)
              .then((x) => {
                toggleHideDialog();
                toggleHideDialogSuccess();
                LoadData();
              })
              .catch((error) => {
                toggleHideDialog();
                toggleHideDialogError();
                LoadData();
              });
          }}
          styles={buttonStyles}
        >
          Agregar
        </PrimaryButton>

        <DefaultButton onClick={() => setOpenPanel(false)}>
          Cancelar
        </DefaultButton>
      </div>
    ),
    [model]
  );

  const onRenderFooterContent2 = React.useCallback(
    () => (
      <div>
        <PrimaryButton
          disabled={model.nombre === "" ? true : false}
          onClick={() => {
            toggleHideDialog2();
            let body: any = {};
            // body.ubicacionId = model.ubicacionId;
            body.ubicacionId = selectedUbicacion;
            body.nombre = model.nombre;
            IPERCService.agregarNivel(body)
              .then((x) => {
                toggleHideDialog2();
                toggleHideDialogSuccess2();
                setmodel(INITIAL_MODULE);
                LoadData2(selectedUbicacion);
              })
              .catch((error) => {
                toggleHideDialog2();
                toggleHideDialogError2();
                setmodel(INITIAL_MODULE);
                LoadData2(selectedUbicacion);
              });
          }}
          styles={buttonStyles}
        >
          Agregar
        </PrimaryButton>

        <DefaultButton
          onClick={() => {
            setOpenPanel2(false);
            setmodel(INITIAL_MODULE);
          }}
        >
          Cancelar
        </DefaultButton>
      </div>
    ),
    [model]
  );

  const _onChange = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    if (newValue != undefined) {
      setmodel({
        ...model,
        nombre: newValue,
      });
    }
  };

  return (
    <div
      className="ms-Grid-col ms-md12 ms-lg12"
      style={{ padding: "0.625rem" }}
    >
      <HeaderTable
        iconName="Location"
        title="Ubicaciones"
        subTitle="Gestión de Ubicaciones"
        horizontalAlign="start"
      />
      <br />
      <Stack>
        <TableBase
          leftBar={_CommandBarItemItems}
          rigthBar={_farItems}
          data={items}
          column={_columns}
          isLoading={false}
          getPageSize={(arg) => { }}
          layout={DetailsListLayoutMode.justified}
        // pagination={pagIngreso}
        />
      </Stack>

      <Dialog
        hidden={hideDialogDelete}
        onDismiss={toggleHideDialogDelete}
        dialogContentProps={{
          title: "Eliminando...",
          subText:
            "¿Está seguro que desea eliminar?, el registro se eliminará permanentemente.",
        }}
      >
        <DialogFooter>
          <PrimaryButton
            onClick={() => {
              var body: any = {};
              body.id = model.ubicacionId;
              IPERCService.eliminarUbicacion(body).then((x) => {
                toggleHideDialogDelete();
                LoadData();
              });
            }}
            text="Aceptar"
          />
          <DefaultButton
            onClick={() => {
              toggleHideDialogDelete();
              LoadData();
            }}
            text="Cancelar"
          />
        </DialogFooter>
      </Dialog>

      <Panel
        isOpen={openPanel2}
        onDismiss={() => setOpenPanel2(false)}
        type={PanelType.medium}
        closeButtonAriaLabel="Close"
        headerText="Gestión de Niveles de Ubicación"
        onRenderFooterContent={onRenderFooterContent2}
        isFooterAtBottom={true}
      >
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <br />
            <TextField
              {...HelpersIpercBase.TextTextFieldElevation}
              value={model.nombre}
              onChange={_onChange}
              onRenderPrefix={(arg) => (
                <FontIcon
                  iconName="Rename"
                  style={{ color: COLORES.Bases.primary }}
                />
              )}
              placeholder="Ingrese nombre de nivel *"
            />
          </div>
          {/* <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <TextField
              label="Nivel"
              placeholder="Ingrese nombre de nivel"
              value={model.nombre}
              onChange={_onChange}
              autoComplete="off" />
          </div> */}
        </div>
        <div className="ms-Grid-col ms-sm12 ms-lg12">
          <br />
          <DetailsList
            items={itmesPanel}
            compact={false}
            selectionMode={SelectionMode.none}
            columns={_columnsPanel}
            setKey="set"
            layoutMode={DetailsListLayoutMode.justified}
            selectionPreservedOnEmptyClick={true}
            ariaLabelForSelectionColumn="Toggle selection"
            ariaLabelForSelectAllCheckbox="Toggle selection for all items"
            checkButtonAriaLabel="select row"
          />
        </div>
        <Dialog
          hidden={hideDialog2}
          onDismiss={toggleHideDialog2}
          dialogContentProps={{
            title: "Enviando Información",
            type: DialogType.normal,
            subText: "Por favor espere un momento",
          }}
        >
          <ProgressIndicator barHeight={5} />
        </Dialog>

        <Dialog
          hidden={hideDialogSuccess2}
          onDismiss={toggleHideDialogSuccess2}
          dialogContentProps={{
            title: "Proceso Correcto",
            subText: "Su solicitud se procesó correctamente!",
          }}
        >
          <div style={{ width: "100%" }}>
            <div style={{ width: "42px", height: "42px", margin: "0 auto" }}>
              <Icon
                iconName="Accept"
                style={{
                  color: theme.palette.themePrimary,
                }}
                className="ms-fontSize-42"
              ></Icon>
            </div>
          </div>

          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                toggleHideDialogSuccess2();
                // setOpenPanel2(false);
              }}
              text="Aceptar"
            />
          </DialogFooter>
        </Dialog>
        <Dialog
          hidden={hideDialogError2}
          onDismiss={toggleHideDialogError2}
          dialogContentProps={{
            title: "Error en Solicitud",
            subText: "Hubo un problema con la información enviada!",
          }}
        >
          <div style={{ width: "100%" }}>
            <div
              style={{
                width: "42px",
                height: "42px",
                margin: "0 auto",
              }}
            >
              <Icon
                iconName="ErrorBadge"
                style={{
                  color: theme.palette.redDark,
                }}
                className="ms-fontSize-42"
              ></Icon>
            </div>
          </div>

          <DialogFooter>
            <DefaultButton onClick={toggleHideDialogError2} text="Aceptar" />
          </DialogFooter>
        </Dialog>
        <Dialog
          hidden={hideDialogDelete2}
          onDismiss={toggleHideDialogDelete2}
          dialogContentProps={{
            title: "Eliminando...",
            subText:
              "¿Está seguro que desea eliminar?, el registro se eliminará permanentemente.",
          }}
        >
          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                var body: any = {};
                body.id = selectedNivel;
                IPERCService.eliminarUbicacion(body).then((x) => {
                  toggleHideDialogDelete2();
                  LoadData2(selectedUbicacion);
                });
              }}
              text="Aceptar"
            />
            <DefaultButton
              onClick={() => {
                toggleHideDialogDelete2();
                LoadData2(model.ubicacionId);
              }}
              text="Cancelar"
            />
          </DialogFooter>
        </Dialog>
      </Panel>

      {/* Nueva ubicacion */}
      <Panel
        isOpen={openPanel}
        //onDismiss={setOpenPanel(false)}
        onDismiss={() => setOpenPanel(false)}
        type={PanelType.smallFixedFar}
        closeButtonAriaLabel="Close"
        headerText="Gestión de Ubicaciones"
        onRenderFooterContent={onRenderFooterContent}
        isFooterAtBottom={true}
      >
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-lg12">
            <br />
            <TextField
              {...HelpersIpercBase.TextTextFieldElevation}
              value={model.nombre}
              onChange={_onChange}
              onRenderPrefix={(arg) => (
                <FontIcon
                  iconName="Rename"
                  style={{ color: COLORES.Bases.primary }}
                />
              )}
              placeholder="Nombre de ubicación *"
            />
          </div>
          {/* <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <TextField
              label="Ubicación"
              placeholder="Ubicación"
              value={model.nombre}
              onChange={_onChange}
              autoComplete="off" />
          </div> */}
        </div>
        <Dialog
          hidden={hideDialog}
          onDismiss={toggleHideDialog}
          dialogContentProps={{
            title: "Enviando Información",
            type: DialogType.normal,
            subText: "Por favor espere un momento",
          }}
        >
          <ProgressIndicator barHeight={5} />
        </Dialog>

        <Dialog
          hidden={hideDialogSuccess}
          onDismiss={toggleHideDialogSuccess}
          dialogContentProps={{
            title: "Proceso Correcto",
            subText: "Su solicitud se procesó correctamente!",
          }}
        >
          <div style={{ width: "100%" }}>
            <div style={{ width: "42px", height: "42px", margin: "0 auto" }}>
              <Icon
                iconName="Accept"
                style={{ color: theme.palette.themePrimary }}
                className="ms-fontSize-42"
              ></Icon>
            </div>
          </div>
          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                toggleHideDialogSuccess();
                setOpenPanel(false);
              }}
              text="Aceptar"
            />
          </DialogFooter>
        </Dialog>

        <Dialog
          hidden={hideDialogError}
          onDismiss={toggleHideDialogError}
          dialogContentProps={{
            title: "Error en Solicitud",
            subText: "Hubo un problema con la información enviada!",
          }}
        >
          <div style={{ width: "100%" }}>
            <div
              style={{
                width: "42px",
                height: "42px",
                margin: "0 auto",
              }}
            >
              <Icon
                iconName="ErrorBadge"
                style={{
                  color: theme.palette.redDark,
                }}
                className="ms-fontSize-42"
              ></Icon>
            </div>
          </div>

          <DialogFooter>
            <DefaultButton onClick={toggleHideDialogError} text="Aceptar" />
          </DialogFooter>
        </Dialog>
      </Panel>
    </div>
  );
}

export default IPERCUbicaciones;
